export const defaultPriceValidator = (t) => (input) => {
    let err = null;
    const parsedInput = parseFloat(input);
    if (!Number.isNaN(parsedInput)) {
        if (!input.match(/^(-?\d+(\.\d{0,2})?)?$/)) {
            err = t('user-configuration.bidding.validation.default-price-invalid-number');
        }
    }
    return err;
};

export const defaultQuantityValidator = (t, minDefaultQuantity) => (input) => {
    let err = null;
    const parsedInput = parseInt(input, 10);
    if (!Number.isNaN(parsedInput)) {
        if (!input.match(/^\d+$/)) {
            err = t('user-configuration.bidding.validation.default-quantity-invalid-integer');
        } else if (parsedInput < minDefaultQuantity) {
            err = t('user-configuration.bidding.validation.default-quantity-lower-than-min', { minDefaultQuantity });
        }
    }
    return err;
};

export const priceStepValidator = (t, minPriceStep) => (input) => {
    let err = null;
    const parsedInput = parseFloat(input);
    if (!Number.isNaN(parsedInput)) {
        if (!input.match(/^(\d+(\.\d{0,2})?)?$/)) {
            err = t('user-configuration.bidding.validation.price-step-invalid-number');
        } else if (parsedInput < minPriceStep) {
            err = t('user-configuration.bidding.validation.price-step-lower-than-min', { minPriceStep });
        }
    }
    return err;
};

export const quantityStepValidator = (t, minQuantityStep) => (input) => {
    let err = null;
    const parsedInput = parseInt(input, 10);
    if (!Number.isNaN(parsedInput)) {
        if (!input.match(/^\d+$/)) {
            err = t('user-configuration.bidding.validation.quantity-step-invalid-integer');
        } else if (parsedInput < minQuantityStep) {
            err = t('user-configuration.bidding.validation.quantity-step-lower-than-min', { minQuantityStep });
        }
    }
    return err;
};
